module.exports = require('./$.global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** /home/rengasturku/nettivanne/~/babel-core/~/core-js/modules/$.html.js
 ** module id = 419
 ** module chunks = 0 1 4 5 6 7 8
 **/